import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./cybersecurityoctaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const CybersecurityOctAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/wcc/r/2708327/465E459C6D1AC7C1DEC3B6D6513D8503" target="_blank" className="pinkify">Watch the On-Demand session</a> from SNG Live: Cybersecurity. We had a great session with cybersecurity leaders in government who discussed how they continue to mature their defenses, protect a remote workforce and create the best strategies for staying ahead of adversaries.<br /><br />
 
 Our first panel on why proactive measures are so important featured Renata Spinks, Cyber Technology Officer of the U.S. Marine Corps Cyberspace Command, and Mike Wayne, Head of Enterprise and Federal Cloud Security at Google Cloud. <br /><br />
  
 In our second panel, Gerald Caron, Director of Enterprise Network Management with the Dept. of State, and Sami Laine, Director of Technology Strategy at Okta, discussed why identity is a force multiplier. <br /><br />
  
 Next, Frank Konieczny, CTO of the U.S. Air Force, and Bryan Rosensteel, Cybersecurity Architect at Duo Security, spoke about zero-trust technology and identity management. <br /><br />
  
 Our fourth panel on accelerating application development and security in government through cloud platform services featured Ron Williams, Deputy Director of GSA’s Cloud.gov, and Shehzad Merchant, Chief Technology Officer at Gigamon. <br /><br />
  
 To close out the session, Jack Donnelly, CISO of the Interior Department, Beau Houser, CISO of the U.S. Census Bureau, and Bruce Brody, CISO of Proofpoint Federal, shared their perspectives on how you must understand your people if you want to understand cloud. <br /><br />

                    </p>
                        
                        <p>
                        <a className="regmobwatch" href="https://event.on24.com/wcc/r/2708327/465E459C6D1AC7C1DEC3B6D6513D8503" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/2708327/465E459C6D1AC7C1DEC3B6D6513D8503" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    
                    
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "oct")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                       
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "oct")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default CybersecurityOctAboutWrap